module.exports = __webpack_public_path__ + "image-6fbce5ed2531.png";